import {Injectable} from '@angular/core';

interface User {
    id: string;
    firstname: string;
    lastname: string;
    email: string;
    phone: string;
    rights?: string[];
}

@Injectable({
    providedIn: 'root'
})
export class AccessService {

    private _token: string = '';
    private _client: any = null;

    get token() {
        return this._token;
    }

    set token(token: string) {
        this._token = token;
    }

    get client() {
        return this._client;
    }

    set client(client: any) {
        this._client = client;
    }
}
